import { Button, Col, Modal, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import { ConfirmationDialogProps } from './ConfirmationDialog';

import './ConfirmationDialog.scss';

type ConfirmationDialogWithBannerProps = ConfirmationDialogProps & {
    banner: JSX.Element;
};

export const DialogBanner = ({ bannerText, icon }: { bannerText: string; icon: JSX.Element }) => {
    return (
        <Row wrap={false} gutter={16} className="ConfirmationDialog__content-container">
            {icon ? <Col flex="none">{icon}</Col> : null}
            <Col flex="auto" className="ConfirmationDialog__Note">
                <span className="ConfirmationDialog__content">{bannerText}</span>
            </Col>
        </Row>
    );
};

export const ConfirmationDialogWithBanner = ({
    banner,
    title,
    visible,
    content,
    onCancel,
    onConfirm,
}: ConfirmationDialogWithBannerProps): JSX.Element => {
    const { t } = useTranslation();
    return (
        <Modal
            className="ConfirmationDialog__container"
            centered
            destroyOnClose
            open={visible}
            closable={false}
            maskClosable={false}
            footer={null}
            width={600}
        >
            {title ? <h3 className="ConfirmationDialog__title">{title}</h3> : null}
            {banner}
            <div className="ConfirmationDialog__content-container">{content}</div>

            <Row justify="end" gutter={16}>
                <Col>
                    <Button className="ConfirmationDialog__button" onClick={onCancel}>
                        {onConfirm ? t('COMMON.NO') : t('COMMON.OK')}
                    </Button>
                </Col>
                {onConfirm ? (
                    <Col>
                        <Button className="ConfirmationDialog__button" onClick={onConfirm}>
                            {t('COMMON.YES')}
                        </Button>
                    </Col>
                ) : null}
            </Row>
        </Modal>
    );
};
